import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
	LOADING: type('[Mini IBE] loading '),
	PUT_FLIGHT_TYPE: type('[Mini IBE] put flight type'),
	PUT_ROUTE_TYPE: type('[Mini IBE] put route type'),
	PUT_ACTIVE_INPUT: type('[Mini IBE] put activeInput'),
	PUT_CURRENT_SEACH_ROUTE: type('[Mini IBE] put current search route index'),
	PUT_SEARCH_ROUTES: type('[Mini IBE] put search routes'),
	PUT_PASSENGERS: type('[Mini IBE] put passengers'),
	PUT_STOPOVERS: type('[Mini IBE] put stopovers'),
	SWAP_SEARCH_ROUTE: type('[Mini IBE] swap route'),
	PUT_RANGE_DATES: type('[Mini IBE] put range dates'),
	PUT_DATE_ONE: type('[Mini IBE] put date one'),
	PUT_IS_STOPOVER: type('[Mini IBE] put isStopover'),
	PUT_DEEPLINK_PARAMS: type('[Mini IBE] put deeplinkParams'),
	RESET: type('[Mini IBE] reset'),
};

export class LoadingAction implements Action {
	type = ActionTypes.LOADING;

	/**
	 *Creates an instance of LoadingAction.
	 * @param {*} [payload]
	 * @memberof LoadingAction
	 */
	constructor(public payload?) { }
}

export class PutFlightType implements Action {
	type = ActionTypes.PUT_FLIGHT_TYPE;

	/**
	 *Creates an instance of PutFlightType.
	 * @param {*} payload
	 * @memberof PutFlightType
	 */
	constructor(public payload: any) { }
}

export class PutRouteType implements Action {
	type = ActionTypes.PUT_ROUTE_TYPE;

	/**
	 *Creates an instance of PutRouteType.
	 * @param {*} payload
	 * @memberof PutRouteType
	 */
	constructor(public payload: any) { }
}

export class SwapRoute implements Action {
	type = ActionTypes.SWAP_SEARCH_ROUTE;

	/**
	 *Creates an instance of SwapRoute.
	 * @param {number} payload
	 * @memberof SwapRoute
	 */
	constructor(public payload: number) { }
}

export class PutCurrentSearchRoute implements Action {
	type = ActionTypes.PUT_CURRENT_SEACH_ROUTE;

	/**
	 *Creates an instance of PutCurrentSearchRoute.
	 * @param {*} payload
	 * @memberof PutCurrentSearchRoute
	 */
	constructor(public payload: any) { }
}

export class PutActiveInput implements Action {
	type = ActionTypes.PUT_ACTIVE_INPUT;

	/**
	 *Creates an instance of PutActiveInput.
	 * @param {*} payload
	 * @memberof PutActiveInput
	 */
	constructor(public payload: string) { }
}

export class PutSearchRoute implements Action {
	type = ActionTypes.PUT_SEARCH_ROUTES;

	/**
	 *Creates an instance of PutSearchRoute.
	 * @param {*} payload
	 * @memberof PutSearchRoute
	 */
	constructor(public payload: any) { }
}

export class PutPassengers implements Action {
	type = ActionTypes.PUT_PASSENGERS;

	/**
	 *Creates an instance of PutPassengers.
	 * @param {*} payload
	 * @memberof PutPassengers
	 */
	constructor(public payload: any) { }
}

export class PutStovers implements Action {
	type = ActionTypes.PUT_STOPOVERS;

	/**
	 *Creates an instance of PutStovers.
	 * @param {*} payload
	 * @memberof PutStovers
	 */
	constructor(public payload: any) { }
}

export class PutIsStopover implements Action {
	type = ActionTypes.PUT_IS_STOPOVER;

	/**
	 *Creates an instance of PutStovers.
	 * @param {*} payload
	 * @memberof PutIsStopover
	 */
	constructor(public payload: boolean) { }
}

export class PutRangeDates implements Action {
	type = ActionTypes.PUT_RANGE_DATES;

	/**
	 *Creates an instance of PutRangeDates.
	 * @param {Array<Date>} payload
	 * @memberof PutRangeDates
	 */
	constructor(public payload: Array<Date>) { }
}

export class PutDateOne implements Action {
	type = ActionTypes.PUT_DATE_ONE;

	/**
	 *Creates an instance of PutDateOne.
	 * @param {Object<Date>} payload
	 * @memberof PutDateOne
	 */
	constructor(public payload: Date) { }
}

export class Reset implements Action {
	type = ActionTypes.RESET;

	/**
	 *Creates an instance of Reset.
	 * @param {*} payload
	 * @memberof Reset
	 */
	constructor(public payload?) { }
}

export class PutDeeplinkParams implements Action {
	type = ActionTypes.PUT_DEEPLINK_PARAMS;

	/**
	 *Creates an instance of PutDeeplinkParams.
	 * @param {*} payload
	 * @memberof PutDeeplinkParams
	 */
	constructor(public payload?) { }
}

export type Actions = LoadingAction | PutFlightType | PutRouteType | PutCurrentSearchRoute | PutActiveInput | PutSearchRoute | SwapRoute | PutPassengers | PutStovers | PutRangeDates | PutDateOne | PutIsStopover | Reset | PutDeeplinkParams;
